// extracted by mini-css-extract-plugin
export var label = "_ro-0";
export var link = "_ro-1";